import type {PropsWithChildren} from 'react'
import {FilterProvider} from './FilterContext'
import {SearchResultsProvider} from './SearchResultsContext'
import {SortProvider} from './SortContext'
import {FeaturedListingsProvider} from './FeaturedListingsContext'
import {RecommendedListingsProvider} from './RecommendedListingsContext'
import {CreatorsProvider} from './CreatorsContext'
import {CategoryProvider} from './CategoryContext'
import {SearchTypeProvider} from './SearchTypeContext'
import {CopilotAppProvider} from './CopilotAppContext'
import {PageProvider} from './PageContext'
import {QueryProvider} from './QueryContext'

export function SearchAndFilterProviderStack({children}: PropsWithChildren) {
  return (
    <SearchResultsProvider>
      <SortProvider>
        <FeaturedListingsProvider>
          <RecommendedListingsProvider>
            <CreatorsProvider>
              <CategoryProvider>
                <SearchTypeProvider>
                  <CopilotAppProvider>
                    <PageProvider>
                      <QueryProvider>
                        <FilterProvider>{children}</FilterProvider>
                      </QueryProvider>
                    </PageProvider>
                  </CopilotAppProvider>
                </SearchTypeProvider>
              </CategoryProvider>
            </CreatorsProvider>
          </RecommendedListingsProvider>
        </FeaturedListingsProvider>
      </SortProvider>
    </SearchResultsProvider>
  )
}
